import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import './candidateSearchSection.css';
import candidateHome from '../../../../assets/images/candidate_homepage.png';
const CandidateSearchSection = () => {
    return (
        <div className='fluid-container'>
            <div className="searchbar-wrapper">
                <div className="image-container">
                    {/* <div className="grid-overlay"></div> */}
                    <img src={candidateHome} alt="Image of Dashboard" className="my-image" />
                </div>
                <br></br>
            </div>
        </div>
    );
};

export default CandidateSearchSection;